// Import from NPM
// -------------------------------------
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

// Import Reducer Routes
// -------------------------------------
import { AuthenticationReducer } from "app/authentication/redux/Authentication.reducer.react";
import { DeckEditorReducer } from "app/blog/redux/DeckEditor.reducer.react";
import { BlogReducer } from "app/blog/redux/Blog.reducer.react";
import { UsersReducer } from "app/adminPanels/redux/Users.reducer.react";

let RootReducer = combineReducers({
    auth: AuthenticationReducer,
    routing: routerReducer,
    deck: DeckEditorReducer,
    blog: BlogReducer,
    users: UsersReducer,
});

export { RootReducer };
